import { CarValuationWidget } from "@/components/valuation/CarValuationWidget";

/**
 * Minimal page for embedding CarValuationWidget in an iframe
 * No header, footer, or navigation - just the widget
 */
const CarValuationEmbed = () => {
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-2">
      <div className="w-full max-w-2xl">
        <CarValuationWidget embedMode={true} />
      </div>
    </div>
  );
};

export default CarValuationEmbed;
